module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-right-38c7e59be772fd5dfe702c5dd1520b97.svg";